module.exports = __webpack_public_path__ + "img/web2.7c585dbf.png";